import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, Observable, take } from 'rxjs';
import { selectUserRole } from '../state/user/user.selectors';
import { UserState } from '../state/user/user.reducer';
import { UserRole } from '../../shared/enums/userRole.enum';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private router: Router, private userStore: Store<UserState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const allowedRoles = route.data['roles'] as UserRole[];

    return this.userStore.select(selectUserRole).pipe(
      filter((role): role is UserRole => !!role), // wait until role is loaded
      take(1),
      map((role) => {
        const hasAccess = allowedRoles.includes(role);
        if (!hasAccess) {
          this.router.navigate(['/meal-planner']);
        }
        return hasAccess;
      })
    );
  }
}

